/**
 *  @class
 *  @function ProductRecommendations
 */
if (!window.customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
  
      this.parent = this.closest('.product-recommendations--parent');
  
    }
    fetchProducts() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
  
          // TD CHANGE - Hide the block outright when the complementary intent returns nothing,
          // rather than leaving an empty container behind on the page.
          if (!recommendations || !recommendations.innerHTML.trim().length) {
            this.hidden = true;
          }
          // END TD CHANGE

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
  
            if ( this.parent ) {
              this.parent.classList.add('product-recommendations--full');
  
              if ( document.body.classList.contains('open-cart')) {
                this.parent.classList.add('active');
              }
            }
  
          }
  
          this.classList.add('product-recommendations--loaded');
  
        })
        .catch(e => {
          console.error(e);
        });
    }
    connectedCallback() {
      this.fetchProducts();
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);
  }
  